// extracted by mini-css-extract-plugin
export var productDownload = "ProductDownload-module--productDownload--CeYTI";
export var inner = "ProductDownload-module--inner--9RlA1";
export var text = "ProductDownload-module--text--MyP9M";
export var buttons = "ProductDownload-module--buttons--7ycW1";
export var image = "ProductDownload-module--image--bWEVq";